<template>
    <section class="container mt-3 py-3">
        <!-- IMPORTANTE FALTAN LOS ESTILOS :C -->
        <h4>Collapses</h4>
        <p class="text-dark my-0"> Tipos de collapses disponibles</p>
        <!-- Default -->
        <div class="my-2 ms-3 my-4">
          <h5>Default</h5>
          <!-- Implementación -->
          <div class="accordion mb-2" id="accordionExample">
              <div class="accordion-item body-3 montserrat-400">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button surface body-2 montserrat-400" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Accordion Item #1
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                  </div>
                </div>
              </div>
              <div class="accordion-item body-3 montserrat-400">
                <h2 class="accordion-header" id="headingTwo">
                  <button class="accordion-button surface collapsed body-2 montserrat-400" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Accordion Item #2
                  </button>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                  </div>
                </div>
              </div>
              <div class="accordion-item body-3 montserrat-400">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button surface collapsed body-2 montserrat-400" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Accordion Item #3
                  </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                  </div>
                </div>
              </div>
          </div>
          <!-- CODIGO HTML -->
          <p class="text-dark my-0"> Código de ejemplo para la implementación de collapse.</p>
          <div v-highlight>
  <pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="accordion" id="accordionExample">
      <div class="accordion-item body-3 montserrat-400">
          <h2 class="accordion-header" id="headingOne">
              <button 
                  class="accordion-button surface body-2 montserrat-400" 
                  type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" 
                  aria-expanded="true" aria-controls="collapseOne"> Accordion Item #1
              </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse show" 
              aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body"> Contenido 1.</div>
          </div>
      </div>
      <div class="accordion-item body-3 montserrat-400">
          <h2 class="accordion-header" id="headingTwo">
              <button 
                  class="accordion-button surface collapsed body-2 montserrat-400" 
                  type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" 
                  aria-expanded="false" aria-controls="collapseTwo"> Accordion Item #2
              </button>
          </h2>
          <div id="collapseTwo" class="accordion-collapse collapse" 
              aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
              <div class="accordion-body"> Contenido 2</div>
          </div>
      </div>
  </div></script></code></pre>

          </div>
        </div>
        <!-- BASIC -->
        <div class="my-2 ms-3 my-4">
          <h5>Básico</h5>
          <!-- Implementación -->
          <p class="text-dark my-0"> Collapse con diseño más discreto que omite algunos bordes y el background.</p>
          <div class="accordion accordion-flush mb-2" id="accordionExampleBasic">
            <div class="accordion-item basic-item body-3 montserrat-400">
              <h2 class="accordion-header" id="headingBasic">
                <button class="accordion-button basic body-2 montserrat-400" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOneBasic" aria-expanded="true" aria-controls="collapseOne">
                  Accordion Item #1
                </button>
              </h2>
              <div id="collapseOneBasic" class="accordion-collapse collapse show" aria-labelledby="headingBasic" data-bs-parent="#accordionExampleBasic">
                <div class="accordion-body">
                  <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                </div>
              </div>
            </div>
            <div class="accordion-item basic-item body-3 montserrat-400">
              <h2 class="accordion-header" id="headingTwoBasic">
                <button class="accordion-button basic collapsed body-2 montserrat-400" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwoBasic" aria-expanded="false" aria-controls="collapseTwo">
                  Accordion Item #2
                </button>
              </h2>
              <div id="collapseTwoBasic" class="accordion-collapse collapse" aria-labelledby="headingTwoBasic" data-bs-parent="#accordionExampleBasic">
                <div class="accordion-body">
                  <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                </div>
              </div>
            </div>
            <div class="accordion-item basic-item body-3 montserrat-400">
              <h2 class="accordion-header" id="headingThreeBasic">
                <button class="accordion-button basic collapsed body-2 montserrat-400" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThreeBasic" aria-expanded="false" aria-controls="collapseThree">
                  Accordion Item #3
                </button>
              </h2>
              <div id="collapseThreeBasic" class="accordion-collapse collapse" aria-labelledby="headingThreeBasic" data-bs-parent="#accordionExampleBasic">
                <div class="accordion-body">
                  <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                </div>
              </div>
            </div>
          </div>
          <!-- CODIGO HTML -->
           <p class="text-dark my-0">Código de ejemplo para la implementación de collapse básico.</p>
          <div v-highlight>
    <pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="accordion accordion-flush" id="accordionExampleBasic">
      <div class="accordion-item basic-item body-3 montserrat-400">
          <h2 class="accordion-header" id="headingBasic">
              <button 
              class="accordion-button basic body-2 montserrat-400" 
              type="button" data-bs-toggle="collapse" data-bs-target="#collapseOneBasic" 
              aria-expanded="true" aria-controls="collapseOne"> Accordion Item #1
              </button>
          </h2>
          <div id="collapseOneBasic" class="accordion-collapse collapse show" 
              aria-labelledby="headingBasic" data-bs-parent="#accordionExampleBasic">
              <div class="accordion-body"> Contenido 1.</div>
          </div>
      </div>
      <div class="accordion-item basic-item body-3 montserrat-400">
          <h2 class="accordion-header" id="headingTwoBasic">
              <button 
              class="accordion-button basic collapsed body-2 montserrat-400" 
              type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwoBasic" 
              aria-expanded="false" aria-controls="collapseTwo"> Accordion Item #2
              </button>
          </h2>
          <div id="collapseTwoBasic" class="accordion-collapse collapse" 
              aria-labelledby="headingTwoBasic" data-bs-parent="#accordionExampleBasic">
              <div class="accordion-body">Contenido 2</div>
          </div>
      </div>
  </div></script></code></pre>
          </div>
        </div>
    </section>
</template>
<script>
  export default{
    created(){
        window.scrollTo(0, 0);
    }
  }
</script>